// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"f04bb718","544":"c1d5dbf2","586":"6973bb3b","605":"846258dc","662":"a6c01a64","743":"2accabcc","770":"c39a0840","807":"1b243584","954":"b7a87cf8"}[chunkId] + ".chunk.js";
};